module.exports = __webpack_public_path__ + "img/upi.d2a16c33.png";